declare global {
  interface Window {
    dataLayer: unknown[];
    fbq?: (...args: unknown[]) => void;
    _fbq?: unknown;
  }
}

const META_PIXEL_ID = import.meta.env.VITE_META_PIXEL_ID as string | undefined;

// Must use 'arguments' (not rest params) — GTM only recognizes consent commands
// when the dataLayer entry is an Arguments object, not a plain Array.
function gtag(_command: string, _action: string, _params?: Record<string, string>): void {
  window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line prefer-rest-params
  window.dataLayer.push(arguments);
}

class MarketingService {
  private pixelLoaded = false;

  init(marketingConsent: boolean): void {
    this.updateConsentSignals(marketingConsent);
    if (marketingConsent) {
      this.loadMetaPixel();
    }
  }

  updateConsentSignals(granted: boolean): void {
    const value = granted ? 'granted' : 'denied';
    gtag('consent', 'update', {
      ad_storage: value,
      analytics_storage: value,
      ad_user_data: value,
      ad_personalization: value,
    });
  }

  pushEvent(event: string, data?: Record<string, string>): void {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...data });
  }

  private loadMetaPixel(): void {
    if (this.pixelLoaded || !META_PIXEL_ID) return;
    this.pixelLoaded = true;

    const f = window;
    const b = document;
    const n = 'script';

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const fbqFn = function (...args: unknown[]) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (fbqFn as any).callMethod
        ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (fbqFn as any).callMethod.apply(fbqFn, args)
        : // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (fbqFn as any).queue.push(args);
    };

    if (!f.fbq) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      f.fbq = fbqFn as any;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (fbqFn as any).push = fbqFn;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (fbqFn as any).loaded = true;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (fbqFn as any).version = '2.0';
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (fbqFn as any).queue = [];

      const script = b.createElement(n) as HTMLScriptElement;
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const firstScript = b.getElementsByTagName(n)[0];
      firstScript.parentNode?.insertBefore(script, firstScript);
    }

    f.fbq?.('init', META_PIXEL_ID);
    f.fbq?.('track', 'PageView');
  }
}

export const marketingService = new MarketingService();
